export const getBonusesTutorialFromStorage = (): string | null => localStorage.getItem('bonusesTutorial');
